import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Permissions } from '@app/core/guard/Permissions';
import { VaultBaseComponent } from '@app/shared/components/base/vault-base.component';
import { TableAction, TableActions } from '@app/shared/components/table/table.component';
import { AppState } from '@app/state';
import { AttachmentType } from '@interfaces/common/attachmentType';
import { Pagination } from '@interfaces/common/pagination';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogService } from '@services/helpers/dialog.service';
import { PaginatorState } from 'primeng/paginator';

@Component({
  selector: 'app-attachment-type-list-content',
  templateUrl: './attachment-type-list-content.component.html',
  styleUrls: ['./attachment-type-list-content.component.scss'],
  standalone: false,
})
export class AttachmentTypeListContentComponent extends VaultBaseComponent implements OnInit {
  @Input() groupList: AttachmentType[] = [];
  @Input() pagination: Pagination = {
    total: 0,
    currentPage: 0,
    pages: 0,
    itemsPerPage: 0,
  };
  /** Primeira listagem em andamento: mantém a tabela visível para o esqueleto aparecer. */
  @Input() loading = false;
  @Output() sendTablePagination: EventEmitter<PaginatorState> = new EventEmitter<PaginatorState>();
  @Output() sendTableSelection: EventEmitter<TableActions<AttachmentType>> = new EventEmitter<
    TableActions<AttachmentType>
  >();
  @Output() sendTableAction: EventEmitter<TableActions<AttachmentType>> = new EventEmitter<
    TableActions<AttachmentType>
  >();

  attachmentTypePermissions = Permissions.DerivativeAttachmentType;
  headers: string[] = [];
  columns: string[] = [];

  constructor(
    translateService: TranslateService,
    store: Store<AppState>,
    private router: Router,
    private dialogService: ConfirmDialogService
  ) {
    super(translateService, store);
  }
  ngOnInit(): void {
    this.headers = [
      this.t(this.tk.Management.Id),
      this.t(this.tk.Management.Name),
      this.t(this.tk.Management.Description),
      this.t(this.tk.Management.Associates),
      '',
    ];
    this.columns = ['id', 'typeName', 'description', '', 'edit'];
  }

  addAttachmentType(): void {
    this.router.navigate(['dashboard/attachment-type/register']);
  }

  handleTableAction(tableAction: TableAction<AttachmentType>) {
    if (tableAction.action === 'edit') {
      this.router.navigate(['dashboard/attachment-type/register', tableAction.item.id]);
    }
  }

  handleTablePagination(pagination: PaginatorState) {
    this.sendTablePagination.emit(pagination);
  }

  handleTableSelection({ action, items }: TableActions<AttachmentType>) {
    switch (action) {
      case 'delete':
        this.dialogService
          .confirm(
            this.t(this.tk.Management.AttachmentTypeDescriptionDeleteConfirmation),
            this.t(this.tk.Management.AttachmentTypeTitleDeleteConfirmation),
            this.t(this.tk.General.Yes),
            this.t(this.tk.General.No)
          )
          .then(response => {
            if (response) {
              this.sendTableAction.emit({ action, items });
            }
          })
          .catch(error => {
            console.error('Error: ', error);
          });
        break;
    }
  }

  get formatedGroupList(): AttachmentType[] {
    const formated = this.groupList.map((group: AttachmentType) => {
      return group;
    });
    return formated;
  }
}
